import type { PDFSessionFactory } from "@pdfking/renderer-api"

export const CreatePDFSession: PDFSessionFactory = func =>
  import("../utils/Proxy").then(({ CreatePDFSession }) =>
    CreatePDFSession(func)
  )
